/* tslint:disable */
/* eslint-disable */
/**
 * Clients API
 * API des listes de clients (personnes ayant au moins un contrat)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminClientListItem
 */
export interface AdminClientListItem {
    /**
     * 
     * @type {string}
     * @memberof AdminClientListItem
     */
    id: string;
    /**
     * "Prénom Nom" (personne physique) ou désignation (personne morale)
     * @type {string}
     * @memberof AdminClientListItem
     */
    name: string;
    /**
     * true = personne morale
     * @type {boolean}
     * @memberof AdminClientListItem
     */
    isCompany: boolean;
    /**
     * Absent si null
     * @type {string}
     * @memberof AdminClientListItem
     */
    email?: string | null;
    /**
     * Absent si null
     * @type {string}
     * @memberof AdminClientListItem
     */
    phone?: string | null;
    /**
     * Date du 1er contrat. Absent si null.
     * @type {Date}
     * @memberof AdminClientListItem
     */
    customerSince?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof AdminClientListItem
     */
    contractCount: number;
    /**
     * Compte tous les risques où la personne apparaît (léger sur-comptage possible côté courtier)
     * @type {number}
     * @memberof AdminClientListItem
     */
    simulationCount: number;
    /**
     * >= 1 contrat en cours
     * @type {boolean}
     * @memberof AdminClientListItem
     */
    hasActiveContract: boolean;
    /**
     * Prime TTC cumulée des quittances
     * @type {number}
     * @memberof AdminClientListItem
     */
    totalPremium: number;
    /**
     * Codes des branches d'assurance des contrats du client
     * @type {Array<string>}
     * @memberof AdminClientListItem
     */
    branches: Array<string>;
    /**
     * Codes des produits des contrats du client (miroir de branches)
     * @type {Array<string>}
     * @memberof AdminClientListItem
     */
    products: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminClientListItem
     */
    brokerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminClientListItem
     */
    brokerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminClientListItem
     */
    plateformeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminClientListItem
     */
    plateformeName?: string | null;
}

/**
 * Check if a given object implements the AdminClientListItem interface.
 */
export function instanceOfAdminClientListItem(value: object): value is AdminClientListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isCompany' in value) || value['isCompany'] === undefined) return false;
    if (!('contractCount' in value) || value['contractCount'] === undefined) return false;
    if (!('simulationCount' in value) || value['simulationCount'] === undefined) return false;
    if (!('hasActiveContract' in value) || value['hasActiveContract'] === undefined) return false;
    if (!('totalPremium' in value) || value['totalPremium'] === undefined) return false;
    if (!('branches' in value) || value['branches'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function AdminClientListItemFromJSON(json: any): AdminClientListItem {
    return AdminClientListItemFromJSONTyped(json, false);
}

export function AdminClientListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminClientListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isCompany': json['isCompany'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'customerSince': json['customerSince'] == null ? undefined : (new Date(json['customerSince'])),
        'contractCount': json['contractCount'],
        'simulationCount': json['simulationCount'],
        'hasActiveContract': json['hasActiveContract'],
        'totalPremium': json['totalPremium'],
        'branches': json['branches'],
        'products': json['products'],
        'brokerId': json['brokerId'] == null ? undefined : json['brokerId'],
        'brokerName': json['brokerName'] == null ? undefined : json['brokerName'],
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
        'plateformeName': json['plateformeName'] == null ? undefined : json['plateformeName'],
    };
}

export function AdminClientListItemToJSON(json: any): AdminClientListItem {
    return AdminClientListItemToJSONTyped(json, false);
}

export function AdminClientListItemToJSONTyped(value?: AdminClientListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'isCompany': value['isCompany'],
        'email': value['email'],
        'phone': value['phone'],
        'customerSince': value['customerSince'] == null ? undefined : ((value['customerSince'] as any).toISOString()),
        'contractCount': value['contractCount'],
        'simulationCount': value['simulationCount'],
        'hasActiveContract': value['hasActiveContract'],
        'totalPremium': value['totalPremium'],
        'branches': value['branches'],
        'products': value['products'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
        'plateformeId': value['plateformeId'],
        'plateformeName': value['plateformeName'],
    };
}

